import { render, staticRenderFns } from "./ReimprimirComp.vue?vue&type=template&id=e1a5ed34&scoped=true&"
import script from "./ReimprimirComp.vue?vue&type=script&lang=js&"
export * from "./ReimprimirComp.vue?vue&type=script&lang=js&"
import style0 from "./ReimprimirComp.vue?vue&type=style&index=0&id=e1a5ed34&button-container=true&scoped=true&lang=css&"
import style1 from "./ReimprimirComp.vue?vue&type=style&index=1&id=e1a5ed34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a5ed34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDialog,VForm,VIcon,VRadio,VRadioGroup,VRow,VSelect,VSpacer,VToolbarTitle})
